import Component from '@glimmer/component';

import { hash } from '@ember/helper';
import { action } from '@ember/object';
import didInsert from '@ember/render-modifiers/modifiers/did-insert';
import { once } from '@ember/runloop';
import { tracked } from '@glimmer/tracking';

import CIdentity from 'rise-ui/components/c-identity.gjs';
import { getSize } from 'rise-ui/utils/dom.js';
import onResize from 'rise-ui/modifiers/on-resize.js';

export default class ReadMoreComponent extends Component {
  containerElement;
  contentElement;
  @tracked readMore;

  onResize() {
    once(this, '_onResize');
  }

  _onResize() {
    if (!this.containerElement || !this.contentElement) {
      return;
    }
    const { height: container } = getSize(this.containerElement);
    const { height: content } = getSize(this.contentElement);
    this.readMore = content > container;
  }

  @action
  onContainerInsert(element) {
    this.containerElement = element;
    this.onResize();
  }

  @action
  onContentInsert(element) {
    this.contentElement = element;
    this.onResize();
  }

  @action
  onContainerResize() {
    this.onResize();
  }

  @action
  onContentResize() {
    this.onResize();
  }

  <template>
    <div class="c-read-more__container" {{didInsert this.onContainerInsert}} {{onResize this.onContainerResize}}>
      <div class="c-read-more__content" {{didInsert this.onContentInsert}} {{onResize this.onContentResize}}>
        {{~yield (hash content=(component CIdentity))~}}
      </div>
      {{#if this.readMore}}
        <div class="c-read-more__button">
          {{~yield (hash button=(component CIdentity))~}}
        </div>
      {{/if}}
    </div>
  </template>
}
